import React from 'react';
import { formatPrice } from '../../../utility/formatPrice';
import { ListingIntent } from '../property-card/PropertyCardTypes';
import { capitalizeWords } from '../../../utility/capitalizeWords';
import { getListingIntentColor } from '../../../utility/property-utilities/listingIntentColor';
import {
  MapPin,
  Building2,
  Euro,
  Bed,
  Bath,
  CalendarDays,
  Clock,
  Tag,
  Maximize2
} from 'lucide-react';

interface PropertyDetailsProps {
  location: string;
  type: string;
  price: number;
  bedrooms: number;
  bathrooms: number;
  availableFrom: string;
  listingIntent: ListingIntent;
  dateAdded: string;
  size: number;
}

const PropertyDetails: React.FC<PropertyDetailsProps> = ({
  location,
  type,
  price,
  bedrooms,
  bathrooms,
  availableFrom,
  dateAdded,
  listingIntent,
  size
}) => {
  const rentAppend = listingIntent === 'rent' ? ' per month' : '';
  return (
    <div className="bg-white p-5 sm:p-6 md:p-8 rounded-xl shadow-lg">
      <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-4 sm:mb-5 md:mb-6">
        Property Details
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5 md:gap-6">
        <div className="flex items-center text-sm sm:text-base text-gray-600">
          <MapPin className="w-5 h-5 sm:w-6 sm:h-6 mr-2 sm:mr-3 text-blue-500 flex-shrink-0" />
          <span>{capitalizeWords(location)}</span>
        </div>
        <div className="flex items-center text-sm sm:text-base text-gray-600">
          <Building2 className="w-5 h-5 sm:w-6 sm:h-6 mr-2 sm:mr-3 text-blue-500 flex-shrink-0" />
          <span>{type}</span>
        </div>
        <div className="flex items-center text-sm sm:text-base text-gray-600">
          <Euro className="w-5 h-5 sm:w-6 sm:h-6 mr-2 sm:mr-3 text-blue-500 flex-shrink-0" />
          <span>
            €{formatPrice(price)} {rentAppend}
          </span>
        </div>
        <div className="flex items-center text-sm sm:text-base text-gray-600 flex-wrap gap-3 sm:gap-4">
          <div className="flex items-center">
            <Bed className="w-5 h-5 sm:w-6 sm:h-6 mr-1.5 sm:mr-2 text-blue-500 flex-shrink-0" />
            <span>{bedrooms} Bed</span>
          </div>
          <div className="flex items-center">
            <Bath className="w-5 h-5 sm:w-6 sm:h-6 mr-1.5 sm:mr-2 text-blue-500 flex-shrink-0" />
            <span>{bathrooms} Bath</span>
          </div>
          {size > 0 && (
            <div className="flex items-center">
              <Maximize2 className="w-5 h-5 sm:w-6 sm:h-6 mr-1.5 sm:mr-2 text-blue-500 flex-shrink-0" />
              <span>{size} m²</span>
            </div>
          )}
        </div>
        {/* <div className="flex items-center text-sm sm:text-base text-gray-600">
          <CalendarDays className="w-5 h-5 sm:w-6 sm:h-6 mr-2 sm:mr-3 text-blue-500 flex-shrink-0" />
          <span>Available from {availableFrom}</span>
        </div> */}
        {/* <div className="flex items-center text-sm sm:text-base text-gray-600">
          <Clock className="w-5 h-5 sm:w-6 sm:h-6 mr-2 sm:mr-3 text-blue-500 flex-shrink-0" />
          <span>Added on {dateAdded}</span>
        </div> */}

        {/* Listing Intent Badge */}
        <div className="flex items-center">
          <div
            className={`inline-flex items-center bg-gradient-to-r ${getListingIntentColor(listingIntent)} text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-semibold shadow-md`}
            style={{ maxWidth: 'fit-content', whiteSpace: 'nowrap' }}
          >
            <Tag className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5 sm:mr-2" />
            <span>
              {listingIntent === 'sale'
                ? 'For Sale By Owner'
                : `For ${capitalizeWords(listingIntent)}`}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyDetails;
